import { Card, Flex } from "antd";

import "./FinanceManagerFinancialsDatatablesCard.scss";

import {
  OpenAccountsReceivableIncentive,
  OpenAccountsReceivableFinanced,
  OpenAccountsReceivableCustomerDirect,
  OpenProjectsDepositsReceived,
} from "financials/components";
import {
  IOpenAccountsReceivableIncentive,
  IOpenAccountsReceivableFinanced,
  IOpenAccountsReceivableCustomerDirect,
  IOpenProjectsDepositsReceived,
} from "financials/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  openAccountsReceivableIncentive?: IOpenAccountsReceivableIncentive[];
  openAccountsReceivableFinanced?: IOpenAccountsReceivableFinanced[];
  openAccountsReceivableCustomerDirect?: IOpenAccountsReceivableCustomerDirect[];
  openProjectsDepositsReceived?: IOpenProjectsDepositsReceived[];
};

export const FinanceManagerFinancialsDatatablesCard = ({
  loading,
  openAccountsReceivableIncentive,
  openAccountsReceivableFinanced,
  openAccountsReceivableCustomerDirect,
  openProjectsDepositsReceived,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='financeManagerFinancialsDatatablesCard'
    >
      <Flex vertical gap={variables.gap}>
        <OpenAccountsReceivableIncentive openAccountsReceivableIncentive={openAccountsReceivableIncentive ?? []} />
        <OpenAccountsReceivableFinanced openAccountsReceivableFinanced={openAccountsReceivableFinanced ?? []} />
        <OpenAccountsReceivableCustomerDirect openAccountsReceivableCustomerDirect={openAccountsReceivableCustomerDirect ?? []} />
        <OpenProjectsDepositsReceived openProjectsDepositsReceived={openProjectsDepositsReceived ?? []} />
      </Flex>
    </Card>
  );
};
